import React from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

const toLocalDateValue = (date) => {
  if (!date) return "";
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
};

export default function CommonDatePicker({
  name,
  value,
  onChange,
  className = "form-control",
  placeholder = "Select date",
  dateFormat = "dd/MM/yyyy",
  ...props
}) {
  const selectedDate = value ? new Date(`${value}T00:00:00`) : null;

  return (
    <DatePicker
      {...props}
      name={name}
      className={className}
      wrapperClassName="np-common-date-picker"
      selected={Number.isNaN(selectedDate?.getTime()) ? null : selectedDate}
      onChange={(date) =>
        onChange?.({ target: { name, value: toLocalDateValue(date) } })
      }
      dateFormat={dateFormat}
      placeholderText={placeholder}
      showIcon
      autoComplete="off"
    />
  );
}
